/* globals google */
import { fromJS } from 'immutable'
import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import MapUtils from './MapUtils'

const MapContainer = styled.div`
  .GMap {
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    margin-top: -20px;
    z-index: 0;
    .GMap-canvas {
      top: 20px;
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
`

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
`

class Map extends Component {
  constructor (props) {
    super(props)
    this.state = {
      zoom: props.zoom,
      mapSettings: {
        zoom: props.zoom,
        scrollwheel: props.scrollable,
        draggable: props.draggable,
        center: new google.maps.LatLng(
          this.props.initialCenter.lat,
          this.props.initialCenter.lng
        ),
        disableDefaultUI: props.disableUI
      }
    }
    this.map = null
    this.markers = []
    this.markerClusters = null
    this.setMarkers = this.setMarkers.bind(this)
    this.clearMarkers = this.clearMarkers.bind(this)
  }

  shouldComponentUpdate (nextProps) {
    const { places } = this.props
    if (!fromJS(places).equals(fromJS(nextProps.places))) {
      return true
    }

    return false
  }

  componentDidMount () {
    this.map = MapUtils.createMap(this.state.mapSettings, this.refs.mapCanvas)
    this.setMarkers(this.props.places)
  }

  componentWillReceiveProps (nextProps) {
    const { initialCenter } = this.props
    if (nextProps.places) {
      this.clearMarkers()
      this.setMarkers(nextProps.places)
    }
    if (
      initialCenter.lat !== nextProps.initialCenter.lat &&
      initialCenter.lng !== nextProps.initialCenter.lng
    ) {
      this.map.setCenter(nextProps.initialCenter)
    }
  }

  componentWillUnmount () {
    this.markers.forEach(marker =>
      google.maps.event.clearListeners(marker, 'click')
    )
  }

  setMarkers (places) {
    this.markers = MapUtils.createMarkers(
      this.map,
      places,
      this.props.handleSelect
    )
    this.markerClusters = MapUtils.createMarkerCluster({
      map: this.map,
      markers: this.markers
    })
  }

  clearMarkers () {
    this.markers.forEach(marker => {
      marker.setMap(null)
    })
    this.markerClusters.clearMarkers()
    this.markerClusters = []
    this.markers = []
  }

  render () {
    return (
      <Container>
        <MapContainer>
          <div className='GMap'>
            <div className='GMap-canvas' ref='mapCanvas' />
          </div>
        </MapContainer>
      </Container>
    )
  }
}

Map.propTypes = {
  initialCenter: PropTypes.object.isRequired,
  places: PropTypes.array.isRequired,
  handleSelect: PropTypes.func,
  zoom: PropTypes.number,
  scrollable: PropTypes.bool,
  draggable: PropTypes.bool,
  disableUI: PropTypes.bool
}

Map.defaultProps = {
  scrollable: true,
  draggable: true,
  disableUI: false,
  zoom: 2
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map/index.js